import { Box, Typography } from "@mui/material";
import vehicleImage from "app/assets/vechile.svg";
import { FilterSelect } from "app/components/FilterSelect";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { actions } from "../../../redux/slice";
import {
  AXLE_STRUCTURE_OPTIONS,
  BOX_TYPE_OPTIONS,
  WorkOrderVehicleDetails,
} from "../../../types";
import { useStyles } from "./styles";

type FieldProps = {
  label: string;
  value: string;
};

type Props = {
  data: WorkOrderVehicleDetails;
};

const DetailField = ({ label, value }: FieldProps) => {
  const styles = useStyles();

  return (
    <Box className={styles.field}>
      <Typography className={styles.label}>{label}</Typography>
      <Box className={styles.valueRow}>
        <Typography className={styles.value}>{value}</Typography>
      </Box>
    </Box>
  );
};

const SummaryBar = ({ data }: Props) => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  const getCustomerName = (key: string) =>
    t(`WORK_ORDER.VEHICLE_DETAILS.CUSTOMER_VALUES.${key}`, key);

  return (
    <Box className={styles.root} dir={i18n.dir()}>
      <Typography className={styles.summaryTitle}>
        {t("QUOTES.DETAILS.HEADER.TITLE")}
      </Typography>
      <Box className={styles.fieldsRow}>
        <Box className={styles.imageCell}>
          <img
            src={vehicleImage}
            alt={t("WORK_ORDER.VEHICLE_DETAILS.VEHICLE_IMAGE_ALT")}
            className={styles.vehicleImage}
          />
        </Box>

        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.WORK_ORDER_NO")}
          value={data.workOrderNo}
        />
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.CUSTOMER_NAME")}
          value={getCustomerName(data.customerName)}
        />
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.SUB_CUSTOMER")}
          value={getCustomerName(data.subCustomer)}
        />
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.CHASSIS")}
          value={data.chassis}
        />
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.MANUFACTURER")}
          value={t(
            `WORK_ORDER.VEHICLE_DETAILS.MANUFACTURER_VALUES.${data.manufacturer}`
          )}
        />
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.MODEL")}
          value={data.model}
        />
        <Box className={`${styles.field} ${styles.dropdownField}`}>
          <Typography className={styles.label}>
            {t("WORK_ORDER.VEHICLE_DETAILS.AXLE_STRUCTURE")}
          </Typography>
          <FilterSelect
            variant="field"
            label={t("WORK_ORDER.VEHICLE_DETAILS.AXLE_STRUCTURE")}
            value={data.axleStructure}
            options={AXLE_STRUCTURE_OPTIONS}
            menuWidth={100}
            getOptionLabel={(value) => value}
            onChange={(value) =>
              dispatch(
                actions.updateVehicleDetailsField({
                  field: "axleStructure",
                  value,
                })
              )
            }
          />
        </Box>
        <DetailField
          label={t("WORK_ORDER.VEHICLE_DETAILS.YEAR")}
          value={data.year}
        />
        <Box className={`${styles.field} ${styles.dropdownField}`}>
          <Typography className={styles.label}>
            {t("WORK_ORDER.VEHICLE_DETAILS.BOX_TYPE")}
          </Typography>
          <FilterSelect
            variant="field"
            label={t("WORK_ORDER.VEHICLE_DETAILS.BOX_TYPE")}
            value={data.boxType}
            options={BOX_TYPE_OPTIONS}
            menuWidth={160}
            getOptionLabel={(value) =>
              t(`WORK_ORDER.VEHICLE_DETAILS.BOX_TYPE_VALUES.${value}`)
            }
            onChange={(value) =>
              dispatch(
                actions.updateVehicleDetailsField({
                  field: "boxType",
                  value,
                })
              )
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SummaryBar;
